module.exports = __webpack_public_path__ + "img/smartmatic-logo.39a2d674.svg";